import { render, staticRenderFns } from "./CompanyJoin.vue?vue&type=template&id=c865770c&scoped=true&"
import script from "./CompanyJoin.vue?vue&type=script&lang=ts&"
export * from "./CompanyJoin.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyJoin.vue?vue&type=style&index=0&id=c865770c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c865770c",
  null
  
)

export default component.exports